module.exports = __webpack_public_path__ + "img/02.068f8f61.jpg";